import {Component, OnInit} from '@angular/core';
import {OidcSecurityService} from "angular-auth-oidc-client";

@Component({
    selector: 'cml-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  constructor(private oidc: OidcSecurityService) { //TODO: remove
  }

  async ngOnInit() {
    this.oidc.checkAuth().subscribe(() => { });
  }
}
